<template>
  <div class="moles__wrapper" :class="{ vertical }">
    <div class="moles" :class="[ type, align, background ]" :style="style">
      <div v-if="icon" class="moles__icon">
        <Icon :name="icon" :size="iconSize" :color="iconColor" type="stroke" />
      </div>
      <Mole
        v-for="index in count"
        v-bind:key="index"
        :type="type"
        :spacing="spacing"
        :reversed="!!(index % 2) != reversed"
        :vertical="vertical"
        :scale="scale"
      ></Mole>
    </div>
  </div>
</template>

<script>
import Mole from '@/lego/components/layout/Mole.vue';
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  components: {
    Mole,
    Icon,
  },
  props: {
    type: {
      type: String,
      default: 'warning',
    },
    background: {
      type: String,
      default: 'warning',
    },
    spacing: {
      type: String,
      default: 'sm',
    },
    count: {
      type: Number,
      default: 4,
    },
    align: {
      type: String,
      default: 'center',
    },
    scale: {
      type: Number,
      default: 1,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'initial',
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    iconSize: {
      type: Number,
      default: 80,
    },
    iconColor: {
      type: String,
      default: 'black',
    },
  },
  setup(props) {
    const style = 'position: ' + props.position + ';' + (!!props.icon ? 'margin-bottom: 4rem;' : '');

    return {
      style,
    };
  },
};
</script>

<style lang="postcss" scoped>
.moles {
  @apply flex items-end w-full;

  &__wrapper {
    @apply relative;

    &.vertical {
      @apply h-full;
    }
  }

  &.center {
    @apply justify-center;
  }
  &.left {
    @apply justify-end;
  }
  &.right {
    @apply justify-start;
  }
  &.justify {
    @apply justify-between;
  }

  &.warning {
    @apply bg-feedback-alert-medium;
  }
  &.info {
    @apply bg-support-dark;
  }
  &.error {
    @apply bg-feedback-error-light;
  }
  &.success {
    @apply bg-feedback-success-medium;
  }
  &.transparent {
    @apply !bg-transparent;
  }

  .vertical & {
    @apply flex-col h-full;
  }

  &__icon {
    @apply absolute -bottom-xl mx-auto flex justify-center w-[17rem] py-xs bg-neutral-white rounded-[22px] z-10 shadow-[0px_12.46px_15.23px_rgba(0,0,0,0.08)];
  }
}
</style>
